import { Component } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import { getCurrentDate, getDisplayDateFrLong } from "../time";

const styles = {
    appBar: {
        position: "relative",
    },
    flex: {
        flex: 1,
    },
};

class RefreshNewDay extends Component {
    render() {
        const { classes } = this.props;

        return (
            <Dialog fullScreen onClose={this.props.exit} aria-labelledby="simple-dialog-title" open={this.props.open}>
                <AppBar className={classes.appBar} elevation={0}>
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.props.exit} aria-label="Close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" color="inherit" className={classes.flex}>
                            Actualisation de la journée
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <div className="" style={{ textAlign: "center", marginTop: "50px", marginBottom: "50px" }}>
                        La journée a changé !
                    </div>
                    <div
                        className="col-lg-10 col-md-10 col-sm-10 col-10 center"
                        style={{ textAlign: "center", marginLeft: "auto", marginRight: "auto" }}
                    >
                        <Button
                            color="secondary"
                            variant="contained"
                            style={{ color: "White", display: "block", textAlign: "auto" }}
                            onClick={this.props.new}
                        >
                            <div className="row">
                                <span className="col-lg-12 col-md-12 col-sm-12 col-12">Aller sur le</span>
                            </div>
                            <div className="row" style={{ paddingTop: "15px" }}>
                                <span className="col-lg-12 col-md-12 col-sm-12 col-12">
                                    {getDisplayDateFrLong(getCurrentDate())}
                                </span>
                            </div>
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        );
    }
}

RefreshNewDay.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RefreshNewDay);
